/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Architect_Output9Inputs */

const en_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page architecture`)
};

const ar_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بنية الصفحات`)
};

const bn_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পৃষ্ঠা আর্কিটেকচার`)
};

const de_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitenarchitektur`)
};

const es_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura de páginas`)
};

const fr_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture de pages`)
};

const pt_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura de páginas`)
};

const zh_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面架构`)
};

const tr_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfa mimarisi`)
};

const ru_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архитектура страниц`)
};

const pl_svc_programmatic_seo_architect_output9 = /** @type {(inputs: Svc_Programmatic_Seo_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektura stron`)
};

/**
* | output |
* | --- |
* | "Page architecture" |
*
* @param {Svc_Programmatic_Seo_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_architect_output9 = /** @type {((inputs?: Svc_Programmatic_Seo_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "de") return de_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "es") return es_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_architect_output9(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_architect_output9(inputs)
	return en_svc_programmatic_seo_architect_output9(inputs)
});
export { svc_programmatic_seo_architect_output9 as "svc_programmatic-seo_ARCHITECT_output" }